import React from 'react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-617">
      <div className="max-w-4xl mx-auto px-6" data-id="element-618">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-619">
          Política de Privacidad
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-620">
          <p className="text-sm text-[#8b6f6f]" data-id="element-621">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-622">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-623">
              1. Información que Recopilamos
            </h2>
            <p data-id="element-624">
              Recopilamos información que usted nos proporciona directamente
              cuando:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-625">
              <li data-id="element-626">Realiza una compra en nuestro sitio web</li>
              <li data-id="element-627">Se suscribe a nuestro boletín informativo</li>
              <li data-id="element-628">Se comunica con nosotros</li>
            </ul>
            <p className="mt-4" data-id="element-629">
              Esta información puede incluir: nombre, dirección de correo
              electrónico, información de pago (procesada de forma segura por
              Hotmart).
            </p>
          </section>

          <section data-id="element-630">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-631">
              2. Cómo Utilizamos su Información
            </h2>
            <p data-id="element-632">Utilizamos la información recopilada para:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-633">
              <li data-id="element-634">Procesar y entregar su compra</li>
              <li data-id="element-635">Enviarle confirmaciones de pedido y actualizaciones</li>
              <li data-id="element-636">Responder a sus consultas y solicitudes de soporte</li>
              <li data-id="element-637">
                Enviarle información promocional (solo si ha dado su
                consentimiento)
              </li>
              <li data-id="element-638">Mejorar nuestros productos y servicios</li>
              <li data-id="element-639">Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section data-id="element-640">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-641">
              3. Compartir Información
            </h2>
            <p data-id="element-642">
              No vendemos, alquilamos ni compartimos su información personal con
              terceros, excepto:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-643">
              <li data-id="element-644">
                Con proveedores de servicios que nos ayudan a operar nuestro
                negocio (como Hotmart para procesamiento de pagos)
              </li>
              <li data-id="element-645">
                Cuando sea requerido por ley o para proteger nuestros derechos
              </li>
              <li data-id="element-646">Con su consentimiento explícito</li>
            </ul>
          </section>

          <section data-id="element-647">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-648">
              4. Cookies y Tecnologías Similares
            </h2>
            <p data-id="element-649">
              Utilizamos cookies y tecnologías similares para mejorar su
              experiencia en nuestro sitio web. Las cookies nos ayudan a:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-650">
              <li data-id="element-651">Recordar sus preferencias</li>
              <li data-id="element-652">Entender cómo utiliza nuestro sitio</li>
              <li data-id="element-653">Mejorar el rendimiento del sitio</li>
              <li data-id="element-654">Proporcionar contenido personalizado</li>
            </ul>
            <p className="mt-4" data-id="element-655">
              Puede configurar su navegador para rechazar cookies, aunque esto
              puede afectar la funcionalidad del sitio.
            </p>
          </section>

          <section data-id="element-656">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-657">
              5. Seguridad de Datos
            </h2>
            <p data-id="element-658">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger su información personal contra acceso no autorizado,
              pérdida o alteración. Sin embargo, ningún método de transmisión
              por Internet es 100% seguro.
            </p>
          </section>

          <section data-id="element-659">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-660">
              6. Sus Derechos
            </h2>
            <p data-id="element-661">Usted tiene derecho a:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-662">
              <li data-id="element-663">Acceder a su información personal</li>
              <li data-id="element-664">Corregir información inexacta</li>
              <li data-id="element-665">Solicitar la eliminación de sus datos</li>
              <li data-id="element-666">Oponerse al procesamiento de sus datos</li>
              <li data-id="element-667">Retirar su consentimiento en cualquier momento</li>
              <li data-id="element-668">
                Presentar una queja ante la autoridad de protección de datos
              </li>
            </ul>
          </section>

          <section data-id="element-669">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-670">
              7. Retención de Datos
            </h2>
            <p data-id="element-671">
              Conservamos su información personal durante el tiempo necesario
              para cumplir con los fines descritos en esta política, a menos que
              la ley requiera o permita un período de retención más largo.
            </p>
          </section>

          <section data-id="element-672">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-673">
              8. Enlaces a Terceros
            </h2>
            <p data-id="element-674">
              Nuestro sitio web puede contener enlaces a sitios de terceros. No
              somos responsables de las prácticas de privacidad de estos sitios.
              Le recomendamos leer sus políticas de privacidad.
            </p>
          </section>

          <section data-id="element-675">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-676">
              9. Cambios a esta Política
            </h2>
            <p data-id="element-677">
              Podemos actualizar esta Política de Privacidad periódicamente. Le
              notificaremos sobre cambios significativos publicando la nueva
              política en esta página y actualizando la fecha de "última
              actualización".
            </p>
          </section>

          <section data-id="element-678">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-679">
              10. Contacto
            </h2>
            <p data-id="element-680">
              Si tiene preguntas sobre esta Política de Privacidad o desea
              ejercer sus derechos, puede contactarnos a través de nuestro
              correo electrónico de soporte.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30" data-id="element-681">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-682">
            ← Volver a la página principal
          </a>
        </div>
      </div>
    </div>;
}